/***********************
 * INDEX TAB6 CONTENT 
 (DEVICE IDENTIFICATIONS)
 ************************/

import React, { useState } from "react"
import PropTypes from "prop-types"
import { Col, Row } from "reactstrap"

//Translation
import { withTranslation } from "react-i18next"

// Importing components
import DeviceIdentificationsTable from "./DeviceIdentificationsTable"
import DeviceIdentificationsChart from "./DeviceIdentificationsChart"
import CardTableBtn from "../CardTableBtn"

const DeviceIdentificationsReporting = props => {
  // Filter view related states
  const [widgetVisible, setWidgetVisible] = useState(true)
  const [tableVisible, setTableVisible] = useState(false)

  return (
    <>
      <Row>
        <Col>
          <CardTableBtn
            widgetVisible={widgetVisible}
            tableVisible={tableVisible}
            setWidgetVisible={setWidgetVisible}
            setTableVisible={setTableVisible}
          />
          <div className="mt-2 mb-1">
            {widgetVisible && (
              <DeviceIdentificationsChart
                minRows={0}
                data={props.data}
                quickGuide={props.quickGuide}
              />
            )}
            {tableVisible && (
              <DeviceIdentificationsTable minRows={0} data={props.data} />
            )}
          </div>
        </Col>
      </Row>
    </>
  )
}

DeviceIdentificationsReporting.propTypes = {
  data: PropTypes.any,
  quickGuide: PropTypes.any,
}

export default withTranslation()(DeviceIdentificationsReporting)
